import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  AccordionCont,
  CloseOpenIconCont,
  SurveyInfoCont,
  SurveyInfoTitle,
  SurveysInfoStats,
} from '../../../components/SurveyAccordion/SurveyAccordion.styles';
import {
  AccordionTileCont,
  TileInfoArea,
  TitleCont,
  TileTitle,
  TileActionIconCont,
} from '../../../components/Accordion/AccordionTile/AccordionTile.styles';
import { ITopicbaseOpenQuestion } from '../../../services/topicbase';
import CloseIcon from '@/assets/icons/closeAllAccordion.svg?react';
import OpenIcon from '@/assets/icons/openAllAccordion.svg?react';
import CircleMinus from '@/assets/icons/minusInCircle.svg?react';
import CirclePlus from '@/assets/icons/plusInCircle.svg?react';

interface IOpenQuestions {
  topicbaseOpenQuestions: ITopicbaseOpenQuestion[];
  activeOpenQuestions: { code: string }[];
  language: string;
  onAdd: (code: string) => void;
  onRemove: (code: string) => void;
}

const OpenQuestions: FC<IOpenQuestions> = ({
  topicbaseOpenQuestions,
  activeOpenQuestions,
  language,
  onAdd,
  onRemove,
}) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);

  const selectedCount = activeOpenQuestions.length;
  const totalCount = topicbaseOpenQuestions.length;

  return (
    <AccordionCont active={false}>
      <CloseOpenIconCont
        data-testid="closeOpenOpenQuestionsBtn"
        onClick={() => setIsExpanded(prev => !prev)}
      >
        {isExpanded ? <CloseIcon /> : <OpenIcon />}
      </CloseOpenIconCont>
      <SurveyInfoCont>
        <SurveyInfoTitle>{t('viewSurvey.body.openQuestions')}</SurveyInfoTitle>
        <SurveysInfoStats>
          <b>{selectedCount}</b>
          {` ${t('viewSurvey.body.of')} `}
          <b>{totalCount}</b>
        </SurveysInfoStats>
      </SurveyInfoCont>

      {isExpanded &&
        topicbaseOpenQuestions.map(q => {
          const isSelected = activeOpenQuestions.some(item => item.code === q.code);
          const text = q.text[language] || q.code;

          return (
            <AccordionTileCont
              key={q.code}
              notAssigned={!isSelected}
              style={{ paddingLeft: '16px', cursor: 'default' }}
            >
              <TileInfoArea>
                <TitleCont style={{ flex: 1, width: 'auto' }}>
                  <TileTitle>{text}</TileTitle>
                </TitleCont>
                {/* TODO: Uncomment when will need open questions integration for ADAPT/PULSE */}
                {/* <TileActionIconCont
                  data-testid={`toggleOpenQuestion-${q.code}`}
                  onClick={e => {
                    e.stopPropagation();
                    isSelected ? onRemove(q.code) : onAdd(q.code);
                  }}
                >
                  {isSelected ? <CircleMinus /> : <CirclePlus />}
                </TileActionIconCont> */}
              </TileInfoArea>
            </AccordionTileCont>
          );
        })}
    </AccordionCont>
  );
};

export default OpenQuestions;
